import React from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
  Badge,
} from "antd";
import { Input } from "antd";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import exploreCountryFourImg from "../assets/images/visaCardImg4.jpg";
import sliderImg from "../assets/images/bannerHotel.jpg";
import cruiseImgOne from "../assets/images/visaOffers1.jpg";
import cruiseImgTwo from "../assets/images/visaOffers2.jpg";
import cruiseImgThree from "../assets/images/visaOffers3.jpg";
import Title from "antd/es/typography/Title";
import ExplorePlaces from "../components/ExplorePlaces";
import ReviewSlider from "../components/ReviewSlider";
import ExploreAttractions from "../components/ExploreAttractions";
import HolidaySearch from "../components/HolidaySearch";
import TourCard from "../components/TourCard";

import TravelEfficient from "../assets/images/travel1.svg";
import TravelEfficientTow from "../assets/images/travel2.svg";
import TravelEfficientThree from "../assets/images/travel3.svg";
import TravelEfficientFour from "../assets/images/travel4.svg";
import ThingsToDoCard from "../components/ThingsToDoCard";

const { Text, Paragraph } = Typography;
const offers = [
  {
    img: cruiseImgOne,
    title: "United Arab Emirates",
    desc: "Get up to $200 extra to spend at sea on",
    visaProcessed: "100k+ Visas Processed",
    price: "₹ 6,600",
    serviceFee: "+ ₹ 590",
  },
  {
    img: cruiseImgTwo,
    title: "Thailand",
    desc: "Get up to $200 extra to spend at sea on",
    visaProcessed: "100k+ Visas Processed",
    price: "₹ 6,600",
    serviceFee: "+ ₹ 590",
  },
  {
    img: cruiseImgThree,
    title: "Vietnam",
    desc: "Get up to $200 extra to spend at sea on",
    visaProcessed: "100k+ Visas Processed",
    price: "₹ 6,600",
    serviceFee: "+ ₹ 590",
  },
];

const cruisePack = [
  {
    id: 1,
    image: exploreCountryImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    title: "Canada Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    title: "China Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 4,
    image: exploreCountryFourImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 5,
    image: exploreCountryImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 6,
    image: exploreCountryTwoImg,
    title: "Canada Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 7,
    image: exploreCountryThreeImg,
    title: "China Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 8,
    image: exploreCountryFourImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 9,
    image: exploreCountryImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 10,
    image: exploreCountryTwoImg,
    title: "Canada Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 11,
    image: exploreCountryThreeImg,
    title: "China Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 12,
    image: exploreCountryFourImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
];

const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const toursForYou = [
  {
    title: "Best Selling UAE Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "International Tourist Visas",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Cruise Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Best Selling Singapore Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
];
const RibbonBadge = () => {
  return (
    <div class="ribbon">
      <span class="ribbon-text"> ★ 4.9 (523)</span>
    </div>
  );
};

const { Search } = Input;
const HolidayPage = () => {
  return (
    <>
      <section className="">
        <HolidaySearch />
      </section>

      <section className="py-6 mt-8">
        <ExplorePlaces
          title="Must-Do Holidays Before"
          titleRed="the Year Ends"
          left="flex-start"
        />
      </section>

      <section className="py-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore <span className="text-danger">Maldives</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="py-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore <span className="text-danger">Ladakh</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Banner Slider  */}
      <section className="py-6">
        <div className="container">
          <Carousel
            autoplay
            dots
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <div className="flex items-center">
              <div className="absolute z-10 inset-0 bg-[linear-gradient(90deg,_rgba(221,21,21,0.8)_0%,_#EC1C1D_100%)]" />
              <Image
                src={sliderImg}
                alt="Slide 1"
                className="w-full !h-full object-cover"
                preview={false}
              />

              <Flex
                className="absolute items-center z-20 inset-0 text-white px-12 py-8"
                align="start"
                justify="space-between"
              >
                <Flex flex={1} justify="space-between" className="" vertical>
                  <Flex justify="start" vertical align="start">
                    <Title
                      level={1}
                      className="!text-white rounded !font-medium !mb-0 !text-4xl"
                    >
                      Experience the Wow
                    </Title>

                    <Title
                      level={2}
                      className="!text-white uppercase rounded !text-5xl !mt-2 !mb-0"
                    >
                      in Every Stay
                    </Title>

                    {/* CTA Button */}
                    <Button
                      type="danger"
                      size="large"
                      className="font-medium text-xl bg-white mt-8 
                      border-none rounded-md px-16 py-8 text-[12273D] w-fit"
                    >
                      Book Now!
                    </Button>
                  </Flex>
                </Flex>

                <Flex
                  flex={1}
                  justify="center"
                  align="center"
                  className=""
                  vertical
                >
                  {/* Box Outline */}

                  <fieldset class="w-full mt-8 border-2 border-white border-solid rounded-[8px] p-6 text-white inline-block relative">
                    <legend class="px-4 w-auto text-xl font-semibold !mb-0 text-center">
                      STARTING PRISE
                    </legend>
                    {/* Diagonal Badge */}
                    <div className="absolute -top-5 -right-8 transform rotate-45 bg-blue-600 text-white text-lg font-bold px-3 py-[2px] shadow-md">
                      <Title
                        level={4}
                        className="!text-white !mb-0 !font-medium"
                      >
                        4N/5D
                      </Title>
                    </div>

                    {/* Price Text */}
                    <h1 className="large font-black leading-none text-center">
                      INR 35,999
                    </h1>
                    <p className="uppercase text-center text-xl font-semibold tracking-wide">
                      PER PERSON (BASED ON 2 PAX)
                    </p>
                  </fieldset>

                  <Flex
                    vertical
                    className="w-[60%] mx-auto"
                    justify="center"
                    align="center"
                  >
                    {/* Decorative Line */}
                    <div className="w-full h-[4px] bg-white rounded-full mt-10 mx-auto"></div>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </Carousel>
        </div>
      </section>

      <section className="py-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore <span className="text-danger">Singapore</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="py-6 px-4 lg:px-0">
        <div className="flex justify-center align-middle items-center mb-6 font-medium">
          <div>
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1 text-center"
              level={2}
            >
              <span className="text-primary">
                Explore Top Must do things in{" "}
              </span>{" "}
              Dubai
            </Title>
            <Paragraph className="!mb-0">
              Culture, nature, thrills, and record-breaking experiences
            </Paragraph>
          </div>
        </div>
        <div className="container">
          <Row gutter={[30, 30]}>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
          </Row>

          <Row gutter={[30, 30]} className="mt-8">
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
          </Row>
        </div>
        <Flex justify="center" align="center" className="mt-10">
          <Button
            size="middle"
            type="default"
            className="font-semibold w-60 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-danger rounded-lg"
          >
            See More
          </Button>
        </Flex>
      </section>

      <section className="py-6 px-4 lg:px-0">
        <div className="flex justify-center align-middle items-center mb-6 font-medium">
          <div>
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1 text-center"
              level={2}
            >
              <span className="text-primary">Find Your Perfect</span> Travel
              Match
            </Title>
            <Paragraph className="!mb-0">
              Culture, nature, thrills, and record-breaking experiences
            </Paragraph>
          </div>
        </div>
        <div className="container">
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficient} preview={false} />
                <Title level={5}>Solo Travelers</Title>
              </Flex>
            </Col>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficientTow} preview={false} />
                <Title level={5}>Couples Travelers</Title>
              </Flex>
            </Col>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficientThree} preview={false} />
                <Title level={5}>Families Travelers</Title>
              </Flex>
            </Col>
            <Col xs={24} lg={6}>
              <Flex align="center" vertical gap={5}>
                <Image src={TravelEfficientFour} preview={false} />
                <Title level={5}>Religious Visitors</Title>
              </Flex>
            </Col>
          </Row>
        </div>
      </section>
      <section className="py-6 px-4 lg:px-0">
        <div className="container">
          <Row gutter={[40, 20]}>
            <Col xs={24} sm={6} md={6} lg={6} xl={8}>
              <ThingsToDoCard />
            </Col>
            <Col xs={24} sm={6} md={6} lg={6} xl={8}>
              <ThingsToDoCard />
            </Col>
            <Col xs={24} sm={6} md={6} lg={6} xl={8}>
              <ThingsToDoCard />
            </Col>
          </Row>
        </div>
      </section>
      <section className="p-6">
        <div className="container">
          {/* Title */}
          <Flex justify="center" align="start" vertical className="my-10">
            <h2 className="text-3xl font-normal text-primary">
              We have some spatial{" "}
              <span className="text-danger">Tours for You!</span>
            </h2>
            <p className="font-normal mt-1">
              Culture, nature, thrills, and record-breaking experiences
            </p>
          </Flex>

          {toursForYou.map((tours, index) => (
            <div key={index} className="mb-8">
              <Title
                level={5}
                className="text-[15px] font-semibold  mb-2 leading-normal"
              >
                {tours.title}
              </Title>
              <Paragraph className="text-xs font-medium  leading-relaxed mb-0">
                {tours.text}
              </Paragraph>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HolidayPage;
